import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon, FormGroup, InputText, Select, TextArea } from '@accessdev/arc-ui-react';

const initiate = {
  header: {
    en: "Having Trouble?",
    es: "¿Teniendo problemas?",
    fr: "Avoir des problèmes?",
    pt: "Tendo problemas?",
    zh: "遇到麻烦？",
    de: "Haben Sie Probleme?",
    it: "Hai problemi?",
    hi: "मुश्किल हो रही है?",
    ja: "トラブルがありますか？",
    tl: "May problema ka ba?",
    ko: "문제가 있습니까?"
  },
  mainText: {
    en: "Having trouble redeeming a deal? Is the address incorrect, or have they moved or are no longer in business?",
    es: "¿Tiene problemas para canjear una oferta? ¿La dirección es incorrecta, o se han mudado o ya no están en el negocio?",
    fr: "Vous rencontrez des difficultés pour valider une offre ? L'adresse est-elle incorrecte, a-t-il déménagé ou n'est-il plus en activité ?",
    pt: "Está com problemas para resgatar uma oferta? O endereço está incorreto, eles se mudaram ou não estão mais no mercado?",
    zh: "无法兑现交易？ 地址是否不正确，或者他们已经搬家或不再营业？",
    de: "Haben Sie Probleme, ein Angebot einzulösen? Ist die Adresse falsch, oder sind sie umgezogen oder nicht mehr im Geschäft?",
    it: "Hai problemi a riscattare un’offerta? L’indirizzo è errato, si sono trasferiti o non sono più in attività?",
    hi: "डील को रिडीम करने में परेशानी हो रही है? पता गलत है, या वे स्थानांतरित हो गए हैं या अब व्यवसाय में नहीं हैं?",
    ja: "取引を引き換えるのに問題がありますか？ 住所が間違っているか、移転したか、または廃業したかですか？",
    tl: "May problema ka ba sa pag-redeem ng isang deal? Mali ba ang address, lumipat na ba sila o hindi na sila nagnenegosyo?",
    ko: "딜을 교환하는 데 문제가 있습니까? 주소가 잘못되었거나 이사했거나 더 이상 영업을 하지 않습니까?"
  },
  button: {
    en: "Report a Problem",
    es: "Informar de un problema",
    fr: "Signaler un problème",
    pt: "Reportar um problema",
    zh: "报告一个问题",
    de: "Ein Problem melden",
    it: "Segnala un problema",
    hi: "समस्या की रिपोर्ट करें",
    ja: "問題を報告する",
    tl: "I-report ang isang problema",
    ko: "문제 신고하기"
  }
};
const submitForm = {
  header: {
    en: "Report a problem",
    es: "Informar de un problema",
    fr: "Signaler un problème",
    pt: "Reportar um problema",
    zh: "报告一个问题",
    de: "Ein Problem melden",
    it: "Segnala un problema",
    hi: "समस्या की रिपोर्ट करें",
    ja: "問題を報告する",
    tl: "I-report ang isang problema",
    ko: "문제 신고하기"
  },
  textInputs: {
    name: {
      en: "Your Name",
      es: "Su nombre",
      fr: "votre nom",
      pt: "Seu nome",
      zh: "你的名字",
      de: "Dein Name",
      it: "Il tuo nome",
      hi: "आपका नाम",
      ja: "あなたの名前",
      tl: "Ang pangalan mo",
      ko: "당신의 이름"
    },
    phone: {
      en: "Your Phone Number",
      es: "Su número de teléfono",
      fr: "Votre numéro de téléphone",
      pt: "Seu número de telefone",
      zh: "你的电话号码",
      de: "Deine Telefonnummer",
      it: "Il tuo numero di telefono",
      hi: "आपका फ़ोन नंबर",
      ja: "あなたの電話番号",
      tl: "Ang iyong numero ng telepono",
      ko: "당신의 전화 번호"
    },
    email: {
      en: "Your Email Address",
      es: "Su dirección de correo electrónico",
      fr: "Votre adresse email",
      pt: "Seu endereço de email",
      zh: "您的电子邮件地址",
      de: "Deine E-Mail-Adresse",
      it: "Il tuo indirizzo email",
      hi: "आपका ईमेल पता",
      ja: "あなたのメールアドレス",
      tl: "Ang iyong email address",
      ko: "당신의 이메일 주소"
    },
    additionalInfo: {
      en: "Additional Information: Please include any additional information.",
      es: "Información adicional: Incluya cualquier información adicional.",
      fr: "Informations supplémentaires : Veuillez inclure toute information supplémentaire.",
      pt: "Informações Adicionais: Por favor, inclua qualquer informação adicional.",
      zh: "附加信息：请包括任何附加信息。",
      de: "Zusätzliche Informationen: Bitte fügen Sie alle zusätzlichen Informationen bei.",
      it: "Informazioni aggiuntive: si prega di includere eventuali informazioni aggiuntive.",
      hi: "अतिरिक्त जानकारी: कृपया कोई अतिरिक्त जानकारी शामिल करें।",
      ja: "追加情報: 追加情報を含めてください。",
      tl: "Karagdagang impormasyon: Mangyaring isama ang anumang karagdagang impormasyon.",
      ko: "추가 정보: 추가 정보를 포함하십시오."
    }
  },
  contactMethods: {
    label: {
      en: "Preferred Contact Method",
      es: "Método de Contacto Preferido",
      fr: "Méthode de contact préférée",
      pt: "Método de Contato Preferido",
      zh: "首选联系方式",
      de: "Bevorzugte Kontaktmethode",
      it: "Metodo di contatto preferito",
      hi: "पसंदीदा संपर्क विधि",
      ja: "優先連絡方法",
      tl: "Preferred na Paraan ng Pakikipag-ugnayan",
      ko: "선호하는 연락 방법"
    },
    email: {
      en: "Email",
      es: "Correo electrónico",
      fr: "E-mail",
      pt: "E-mail",
      zh: "电子邮件",
      de: "E-Mail",
      it: "E-mail",
      hi: "ईमेल",
      ja: "Eメール",
      tl: "Email",
      ko: "이메일"
    },
    phone: {
      en: "Phone",
      es: "Teléfono",
      fr: "Téléphoner",
      pt: "Telefone",
      zh: "电话",
      de: "Telefon",
      it: "Telefono",
      hi: "फ़ोन",
      ja: "電話",
      tl: "Telepono",
      ko: "전화"
    },
    noContact: {
      en: "No Contact",
      es: "Sin contacto",
      fr: "Pas de contact",
      pt: "Sem contato",
      zh: "没有联系",
      de: "Kein Kontakt",
      it: "Nessun contatto",
      hi: "कोई संपर्क नहीं",
      ja: "連絡なし",
      tl: "Walang Contact",
      ko: "연락 안 함"
    }
  },
  redeemTypes: {
    label: {
      en: "How did you try to redeem this offer",
      es: "¿Cómo intentaste canjear esta oferta?",
      fr: "Comment avez-vous essayé de profiter de cette offre",
      pt: "Como você tentou resgatar esta oferta",
      zh: "您是如何尝试兑换此优惠的",
      de: "Wie haben Sie versucht, dieses Angebot einzulösen?",
      it: "Come hai provato a riscattare questa offerta",
      hi: "आपने इस ऑफ़र को कैसे भुनाने की कोशिश की",
      ja: "このオファーをどのように引き換えようとしましたか",
      tl: "Paano mo sinubukan i-redeem ang alok na ito",
      ko: "이 제안을 어떻게 교환하려고 했습니까"
    },
    print: {
      en: "Print Coupon",
      es: "Imprimir cupón",
      fr: "Imprimer le coupon",
      pt: "Imprimir cupom",
      zh: "打印优惠券",
      de: "Gutschein drucken",
      it: "Stampa coupon",
      hi: "कूपन प्रिंट करें",
      ja: "クーポンを印刷",
      tl: "I-print ang Kupon",
      ko: "쿠폰 인쇄"
    },
    online: {
      en: "Online Link",
      es: "Enlace en línea",
      fr: "Lien en ligne",
      pt: "Link on-line",
      zh: "在线链接",
      de: "Online-Link",
      it: "Link online",
      hi: "ऑनलाइन लिंक",
      ja: "オンラインリンク",
      tl: "Online Link",
      ko: "온라인 링크"
    },
    mobile: {
      en: "Mobile Coupon",
      es: "Cupón móvil",
      fr: "Coupon mobile",
      pt: "Cupom para celular",
      zh: "移动优惠券",
      de: "Mobiler Gutschein",
      it: "Coupon mobile",
      hi: "मोबाइल कूपन",
      ja: "モバイルクーポン",
      tl: "Mobile Kupon",
      ko: "모바일 쿠폰"
    },
    call: {
      en: "Called Location",
      es: "Ubicación llamada",
      fr: "Emplacement appelé",
      pt: "Local chamado",
      zh: "调用位置",
      de: "Angerufener Ort",
      it: "Posizione chiamata",
      hi: "कॉल की गई लोकेशन",
      ja: "呼び出し場所",
      tl: "Tinawag na Lokasyon",
      ko: "호출된 위치"
    }
  },
  submitBtn: {
    en: "Report Problem",
    es: "Reportar problema",
    fr: "Signaler un problème",
    pt: "Reportar problema",
    zh: "报告问题",
    de: "Problem melden",
    it: "Segnala problema",
    hi: "समस्या की रिपोर्ट करें",
    ja: "問題を報告する",
    tl: "Iulat ang Problema",
    ko: "문제 신고"
  },
  error: {
    en: "*There was an error, please try again.",
    es: "*Hubo un error, por favor intente de nuevo.",
    fr: "*Une erreur s'est produite, veuillez réessayer.",
    pt: "*Ocorreu um erro, tente novamente.",
    zh: "*出现了一个错误，请重试。",
    de: "*Es gab einen Fehler, bitte versuchen Sie es erneut.",
    it: "*Si è verificato un errore, riprova.",
    hi: "*कोई त्रुटि हुई, कृपया पुनः प्रयास करें।",
    ja: "*エラーが発生しました。もう一度やり直してください。",
    tl: "*Nagkaroon ng error, pakisubukan muli.",
    ko: "*오류가 발생했습니다. 다시 시도해 주세요."
  }
};
const loading = {
  header: {
    en: "Thank You!",
    es: "¡Gracias!",
    fr: "Merci!",
    pt: "Obrigada!",
    zh: "谢谢你！",
    de: "Danke!",
    it: "Grazie!",
    hi: "धन्यवाद!",
    ja: "ありがとう！",
    tl: "Salamat!",
    ko: "감사합니다!"
  },
  mainText: {
    en: "Your report has been submitted!",
    es: "¡Su informe ha sido enviado!",
    fr: "Votre rapport a été soumis!",
    pt: "O seu relatório foi apresentado!",
    zh: "您的报告已提交！",
    de: "Ihr Bericht wurde eingereicht!",
    it: "Il tuo rapporto è stato inviato!",
    hi: "आपकी रिपोर्ट जमा कर दी गई है!",
    ja: "あなたの報告書が提出されました！",
    tl: "Naipasa na ang iyong ulat!",
    ko: "보고서가 제출되었습니다!"
  }
};

var _jsxFileName$4 = "/Users/bill.boyd/Work/Access/SOURCE/git/aip-ui/libs/feedback/client/src/lib/ReportAProblem/subcomponents/Initiate.jsx";
function Initiate({
  setFormOpen,
  language
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "ReportAProblem-initiate",
    "data-testid": "Initiate",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 6,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("h4", {
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 7,
      columnNumber: 7
    }
  }, initiate.header[language]), /*#__PURE__*/React.createElement("p", {
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 8,
      columnNumber: 7
    }
  }, initiate.mainText[language]), /*#__PURE__*/React.createElement(Button, {
    onClick: () => setFormOpen(true),
    themeColor: "error",
    displayStyle: "link",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 9,
      columnNumber: 7
    }
  }, initiate.button[language]));
}

const XSRF_HEADER_NAME = "__Secure-adc.x-xsrf-token";
const doPostFetch = (url, body) => {
  return fetch(url, {
    method: "POST",
    body: JSON.stringify(body),
    credentials: "same-origin",
    headers: {
      [XSRF_HEADER_NAME]: getXtoken(),
      "Content-Type": "application/json"
    }
  }).then(response => jsonOrError(response)).then(data => data).catch(rejectErrors);
};
function jsonOrError(response) {
  if (response.ok) {
    return response.json();
  } else {
    const {
      status,
      statusText
    } = response;
    return response.json().then(data => {
      return Promise.reject({
        statusText,
        status,
        data
      });
    });
  }
}
function rejectErrors(error) {
  console.log(error);
  return Promise.reject(error);
}
function getXCookie() {
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(";");
  let token = "";
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    // all adc xsrf have a format of `adc_<app-code>_meta`
    // so match on the start and end of the name to find the cookie.
    if (c.includes("adc_") && c.includes("_meta")) {
      token = c.split("=")[1];
    }
  }
  return token;
}
function getXtoken() {
  const token = getXCookie();
  return token;
}

var _jsxFileName$3 = "/Users/bill.boyd/Work/Access/SOURCE/git/aip-ui/libs/feedback/client/src/lib/ReportAProblem/subcomponents/SubmitForm.jsx";
function SubmitForm({
  setFormOpen,
  offerData,
  setIsLoading,
  error,
  setError,
  language
}) {
  const [formValues, setFormValues] = React.useState({
    name: offerData.member_name,
    phoneNumber: "",
    email: offerData.member_email,
    howToContact: submitForm.contactMethods.email[language],
    redeemType: submitForm.redeemTypes.online[language],
    additionalInfo: ""
  });
  const salesforceParams = {
    "00N80000003vK0F": "Deals Submission",
    "005C0000006fseF": "Taylor Hatchell",
    "origin": offerData.origin,
    "00NC0000005qcnj": "Report A Problem",
    "status": "open",
    "00N80000003vK9v": "Member",
    "00NC0000005qcnj_ilecell": "00G1A000002U9Ab",
    "00NC0000006Mysl": offerData.location_id,
    "subject": offerData.location,
    "012C0000000i4pQ": "RecordType",
    "00N800000049BUf": formValues.name,
    "00N800000049BQy": formValues.phoneNumber,
    "00N800000049BUz": formValues.email,
    "00N8L000000ObHW": formValues.howToContact,
    "00N8L000000ObHR": formValues.redeemType,
    "description": formValues.additionalInfo
  };
  /** NOTE: the following SF params are set in the feedback controller
   * 00N1A000006G1Dg :: program_key
   * 00N1A000006G1Dl :: program_name
   * 00N800000049BUp :: member_id
   */

  const contactMethods = [submitForm.contactMethods.email[language], submitForm.contactMethods.phone[language], submitForm.contactMethods.noContact[language]];
  const redeemTypes = [submitForm.redeemTypes.print[language], submitForm.redeemTypes.online[language], submitForm.redeemTypes.mobile[language], submitForm.redeemTypes.call[language]];
  const isPhoneContactMethod = formValues.howToContact === contactMethods[1];
  const onFormChange = event => {
    const {
      name,
      value
    } = event.target;
    if (error) setError(null);
    setFormValues(prevState => Object.assign({}, prevState, {
      [name]: value
    }));
  };
  const onFormSubmit = async event => {
    setIsLoading(true);
    try {
      const {
        howToContact,
        redeemType
      } = getContactAndRedeemType();
      const result = await doPostFetch("/api/feedback/problem", {
        params: salesforceParams,
        howToContact,
        redeemType
      });
      if (result.success) {
        setTimeout(() => {
          setIsLoading(false);
          setFormOpen(false);
        }, 1000);
      } else {
        setIsLoading(false);
        setError(submitForm.error[language]);
      }
    } catch (err) {
      console.error(err);
      setIsLoading(false);
      setError(submitForm.error[language]);
    }
  };
  const getContactAndRedeemType = () => {
    let howToContact = formValues.howToContact;
    let redeemType = formValues.redeemType;
    // If language is not english, translate values
    if (language !== "en") {
      const contactMethodsEnglishMapping = {
        0: submitForm.contactMethods.email["en"],
        1: submitForm.contactMethods.phone["en"],
        2: submitForm.contactMethods.noContact["en"]
      };
      const redeemTypesEnglishMapping = {
        0: submitForm.redeemTypes.print["en"],
        1: submitForm.redeemTypes.online["en"],
        2: submitForm.redeemTypes.mobile["en"],
        3: submitForm.redeemTypes.call["en"]
      };
      for (let index in contactMethods) {
        if (formValues.howToContact === contactMethods[index]) {
          howToContact = contactMethodsEnglishMapping[index];
          break;
        }
      }
      for (let index in redeemTypes) {
        if (formValues.redeemType === redeemTypes[index]) {
          redeemType = redeemTypesEnglishMapping[index];
          break;
        }
      }
    }
    return {
      redeemType,
      howToContact
    };
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "ReportAProblem-submitForm",
    "data-testid": "SubmitForm",
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 128,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "ReportAProblem-submitForm_header",
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 129,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("h4", {
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 130,
      columnNumber: 9
    }
  }, submitForm.header[language]), /*#__PURE__*/React.createElement(Icon, {
    type: "button",
    className: "ReportAProblem-submitForm_close",
    icon: "close",
    onClick: () => setFormOpen(false),
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 131,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(FormGroup, {
    onSubmit: onFormSubmit,
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 139,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "ReportAProblem-submitForm_form",
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 140,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "ReportAProblem-submitForm_inputs",
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 141,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(InputText, {
    isRequired: true,
    placeHolder: submitForm.textInputs.name[language],
    value: formValues.name,
    name: "name",
    onChange: onFormChange,
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 142,
      columnNumber: 13
    }
  }), isPhoneContactMethod ? /*#__PURE__*/React.createElement(InputText, {
    isRequired: true,
    placeHolder: submitForm.textInputs.phone[language],
    value: formValues.phoneNumber,
    name: "phoneNumber",
    validate: "phone",
    onChange: onFormChange,
    key: "phone-required",
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 150,
      columnNumber: 15
    }
  }) : /*#__PURE__*/React.createElement(InputText, {
    isRequired: false,
    placeHolder: submitForm.textInputs.phone[language],
    value: formValues.phoneNumber,
    name: "phoneNumber",
    validate: "phone",
    onChange: onFormChange,
    key: "phone-notRequired",
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 160,
      columnNumber: 15
    }
  }), /*#__PURE__*/React.createElement(InputText, {
    isRequired: true,
    placeHolder: submitForm.textInputs.email[language],
    value: formValues.email,
    validate: "email",
    name: "email",
    onChange: onFormChange,
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 171,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement(Select, {
    options: contactMethods,
    label: submitForm.contactMethods.label[language],
    selectedValue: formValues.howToContact,
    onChange: value => onFormChange({
      target: {
        name: "howToContact",
        value
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 179,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement(Select, {
    options: redeemTypes,
    label: submitForm.redeemTypes.label[language],
    selectedValue: formValues.redeemType,
    onChange: value => onFormChange({
      target: {
        name: "redeemType",
        value
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 185,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement(TextArea, {
    isRequired: true,
    placeHolder: submitForm.textInputs.additionalInfo[language],
    value: formValues.additionalInfo,
    name: "additionalInfo",
    onChange: onFormChange,
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 191,
      columnNumber: 13
    }
  })), error && /*#__PURE__*/React.createElement("div", {
    className: "ReportAProblem-submitForm_error",
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 199,
      columnNumber: 21
    }
  }, error), /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    className: "ReportAProblem-submitForm_submitBtn",
    themeColor: "error",
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 200,
      columnNumber: 11
    }
  }, submitForm.submitBtn[language]))));
}

var _jsxFileName$2 = "/Users/bill.boyd/Work/Access/SOURCE/git/aip-ui/libs/feedback/client/src/lib/ReportAProblem/subcomponents/Loading.jsx";
function Loading({
  language
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "ReportAProblem-loading",
    "data-testid": "Loading",
    __self: this,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 5,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "ReportAProblem-loading_container mobile-extra-margin-top",
    __self: this,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 6,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "ReportAProblem-loading_inner",
    __self: this,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 7,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "ReportAProblem-loading_wrapper",
    __self: this,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 8,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement("h2", {
    __self: this,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 9,
      columnNumber: 13
    }
  }, loading.header[language]), /*#__PURE__*/React.createElement("p", {
    __self: this,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 10,
      columnNumber: 13
    }
  }, loading.mainText[language]), /*#__PURE__*/React.createElement("div", {
    className: "ReportAProblem-loading_spinner",
    __self: this,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 11,
      columnNumber: 13
    }
  })))));
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$1 = "/** Use this mixin to completely clear out any button like defaults */\n/** Use this mixin to have the button lose it's border and background */\n.ReportAProblem {\n  background: var(--white);\n  font-size: var(--t-xs);\n  width: 100%;\n  bottom: 0;\n}\n.ReportAProblem-initiate, .ReportAProblem-submitForm {\n  background: var(--white);\n  padding: 40px 20px;\n}\n\n.ReportAProblem-submitForm_header {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n}\n.ReportAProblem-submitForm_header h4 {\n  margin-bottom: 0;\n}\n.ReportAProblem-submitForm_close {\n  cursor: pointer;\n}\n.ReportAProblem-submitForm_form {\n  display: flex;\n  flex-flow: column;\n  align-items: center;\n}\n.ReportAProblem-submitForm_inputs {\n  display: flex;\n  flex-flow: column;\n  width: 100%;\n  gap: 20px;\n}\n.ReportAProblem-submitForm_submitBtn {\n  margin-top: 40px;\n}\n.ReportAProblem-submitForm_error {\n  color: var(--error);\n  margin-top: 15px;\n}\n.ReportAProblem-submitForm_phoneInput {\n  display: none;\n}\n\n.ReportAProblem-loading {\n  display: flex;\n  flex-flow: column;\n  justify-content: center;\n  align-items: center;\n  background: var(--white);\n  min-height: 645px;\n}\n.ReportAProblem-loading_wrapper {\n  display: flex;\n  flex-flow: column;\n  align-items: center;\n  justify-content: center;\n}\n.ReportAProblem-loading_wrapper p {\n  font-size: var(--t-sm);\n  margin-bottom: 50px;\n}\n.ReportAProblem-loading_spinner {\n  animation: spinning 1.5s infinite linear;\n  transform: translateZ(0);\n  border: 0.4em solid var(--black_07);\n  border-left-color: var(--primary);\n  font-size: 1em;\n  margin: 0 auto;\n  overflow: hidden;\n  position: relative;\n  text-indent: -9999em;\n  border-radius: 50%;\n  height: 6em;\n  width: 6em;\n}\n.ReportAProblem-loading_spinner::after {\n  border-radius: 50%;\n  height: 6em;\n  width: 6em;\n}\n@keyframes spinning {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}";
styleInject(css_248z$1);

var _jsxFileName$1 = "/Users/bill.boyd/Work/Access/SOURCE/git/aip-ui/libs/feedback/client/src/lib/ReportAProblem/ReportAProblem.jsx";
function ReportAProblem(props) {
  const [formOpen, setFormOpen] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const renderFormOrLoading = () => {
    if (isLoading) {
      return /*#__PURE__*/React.createElement(Loading, {
        language: props.language,
        __self: this,
        __source: {
          fileName: _jsxFileName$1,
          lineNumber: 14,
          columnNumber: 14
        }
      });
    }
    return /*#__PURE__*/React.createElement(SubmitForm, {
      setFormOpen: setFormOpen,
      offerData: props.offerData,
      setIsLoading: setIsLoading,
      language: props.language,
      error: error,
      setError: setError,
      __self: this,
      __source: {
        fileName: _jsxFileName$1,
        lineNumber: 17,
        columnNumber: 7
      }
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "ReportAProblem",
    __self: this,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 29,
      columnNumber: 5
    }
  }, formOpen ? renderFormOrLoading() : /*#__PURE__*/React.createElement(Initiate, {
    setFormOpen: setFormOpen,
    language: props.language,
    __self: this,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 33,
      columnNumber: 9
    }
  }));
}

var css_248z = "/** Use this mixin to completely clear out any button like defaults */\n/** Use this mixin to have the button lose it's border and background */";
styleInject(css_248z);

var _jsxFileName = "/Users/bill.boyd/Work/Access/SOURCE/git/aip-ui/libs/feedback/client/src/lib/Feedback.js";
function Feedback({
  type = "Report a problem",
  offerData,
  language = "en"
}) {
  if (type === "Report a problem") {
    return /*#__PURE__*/React.createElement(ReportAProblem, {
      offerData: offerData,
      language: language,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 9,
        columnNumber: 12
      }
    });
  }
  return null;
}
Feedback.propTypes = {
  // Add other cases here for other Feedback related shared UIs
  type: PropTypes.oneOf(["Report a problem"]).isRequired,
  offerData: PropTypes.shape({
    member_name: PropTypes.string.isRequired,
    member_email: PropTypes.string.isRequired,
    offer_key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    location: PropTypes.string.isRequired,
    location_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    origin: PropTypes.string.isRequired
  }).isRequired,
  language: PropTypes.oneOf(["en", "es", "fr", "pt", "zh", "de", "it", "hi", "ja", "tl", "ko"]).isRequired
};
const alphaNumRegex = new RegExp("^[A-Za-z0-9&?!%$,-.]+$");
const alphaNumericValidator = value => {
  if (!value) {
    return false;
  }
  value = value.trim().replace(/\s/g, "");
  if (alphaNumRegex.test(value)) {
    return true;
  }
  return false;
};

export { Feedback, alphaNumericValidator };
